export const MODE_SINGLE = 0;
export const MODE_REPEAT_ONE = 1;
export const MODE_REPEAT_ALL = 2;

export const GRANTED = 'granted';

export const STATE_STOPPED = 0;
export const STATE_STARTED = 1;
export const STATE_PAUSE_STOPPED = 2;
export const STATE_PAUSE_STARTED = 3;
export const STATE_BIG_BREAK_STOPPED = 4;
export const STATE_BIG_BREAK_STARTED = 5;



// WEBPACK FOOTER //
// ./src/util/constants.js